<template>
  <div
      v-if="isReady && isSignedIn && backups.length > 0"
      class="table-container">
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Created</th>
          <th>Size</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="backup in backups"
            :key="backup.fileId">
          <td>
            {{ backup.name }}
          </td>
          <td :title="backup.created | relativeDate | createdPrefix">
            {{ backup.created | date }}
          </td>
          <td>
            {{ backup.size | humanFileSize }}
          </td>
          <td>
            <base-button
                title="Restore"
                icon="restore"
                type="transparent"
                @click="restoreBackup(backup)"/>
            <base-button
                title="Delete"
                icon="delete"
                type="transparent"
                @click="deleteBackup(backup)"/>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="hasNextPage">
        <tr>
          <td>
            <base-button
                :text="isLoading ? 'Loading...' : 'Load More'"
                :disabled="isLoading"
                type="transparent"
                @click="loadMoreResults"/>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div
      v-else-if="isReady && isSignedIn && backups.length === 0 && !isLoading"
      class="message-container">
    You have no backups.
  </div>
  <div
      v-else-if="isLoading"
      class="message-container">
    Loading...
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BaseButton from '@/components/core/BaseButton.vue';

export default {
  name: 'GoogleBackupTable',
  components: {
    BaseButton,
  },
  filters: {
    createdPrefix(value) {
      return `Created ${value}`;
    },
  },
  props: {
    restoreBackup: Function,
    deleteBackup: Function,
  },
  computed: {
    ...mapState({
      isReady: state => state.googleDriveBackup.isReady,
      isSignedIn: state => state.googleDriveBackup.isSignedIn,

      backups: state => state.googleDriveBackup.backups,
      hasNextPage: state => state.googleDriveBackup.hasNextPage,
      isLoading: state => state.googleDriveBackup.isLoading,
    }),
  },
  mounted() {
    this.loadBackups();
  },
  methods: {
    loadBackups() {
      if (this.isSignedIn) {
        this.$store.dispatch('googleDriveBackup/load');
      }
    },
    loadMoreResults() {
      this.$store.dispatch('googleDriveBackup/loadNextPage');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
.table-container {
  background: $light-background;
  border-radius: 0.5rem;
  overflow: auto;

  table {
    display: grid;
    grid-template-columns:
      minmax(auto, 2fr)
      minmax(auto, auto)
      minmax(auto, auto)
      minmax(auto, auto);
    width: 100%;

    thead, tbody, tfoot, tr {
      display: contents;
    }

    td, th {
      align-items: center;
      display:flex;
    }

    thead th {
      background: $light-background;
      border-bottom: 0.0625rem solid $background;
      padding: 0.5rem 1rem;
      position: sticky;
      top: 0;
    }

    tbody td {
      background: $light-background;
      border-bottom: 0.0625rem solid $background;
      padding: 0.25rem 1rem;
      transition: background .2s;

      // Make actions column have different padding
      &:nth-child(4n) {
        padding: 0.25rem 0.25rem;
      }
    }

    tfoot td {
      grid-column: span 4;
      justify-content: center;

      button {
        border-radius: 0;
        margin: 0;
        padding: 1rem;
        width: 100%;
      }
    }
  }
}

.message-container {
  border-radius: 0.5rem;
  border: 0.0675rem solid $light-background;
  display: flex;
  justify-content: center;
  padding: 1rem;
}
</style>
